export async function idle(scope, ctx) {
    const { hud, gameLogic } = ctx;

    hud.setIdleState();
    hud.setBalance(gameLogic.balance);
    hud.setBet(gameLogic.bet);

    return new Promise((resolve) => {
        scope.on(hud.onSpin, () => resolve("spin"));
        scope.on(hud.onAutoplay, () => resolve("autoplay"));
        scope.on(hud.onSettings, () => resolve("settings"));
        scope.on(hud.onInfo, () => resolve("info"));
        scope.on(hud.onBetSelect, () => resolve("betSelect"));
    });
}
